<template>
  <layout>
    <div class="section">
      <div class="content">
        <div style="font-size: 24px; font-weight: Bold">Whois 查询</div>
        <div class="search-input-warp">
          <div class="flex-content">
            <Input
              class="search-input"
              placeholder="请输入域名信息"
              clearable
              v-model.trim="search"
              maxlength="30"
              @on-keyup="change"
              @on-enter="searchEvnet"
            ></Input>
            <Button class="search-btn" type="primary" @click="searchEvnet"
              >查询</Button
            >
          </div>
        </div>
        <div class="whois-left">
          <div class="form-tit">什么是Whois查询？</div>
          <div class="form-stit">
            您可以用Whois来查看域名的当前信息状态，包括域名是否已被注册、注册日期、过期日期、域名状态、DNS解析服务器等。
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>


<script>
import layout from "./components/layout.vue";
export default {
  name: "price",
  components: {
    layout,
  },
  data() {
    return {
      search: "",
    };
  },
  methods: {
    change() {
      this.search = this.search.replace(/\s+/g, "");
    },
    // 搜索
    searchEvnet() {
      if (!this.search) {
        this.$Message.warning("请输入查询的域名信息！");
        return false;
      }
      const domain =
        // eslint-disable-next-line max-len
        /[^.]+\.(top|com.cn|com|cn|xyz|club|中国|网址|work|vip|beer|在线|net.cn|tv|org.cn|org|name|cc|中文网|info|pro|red|网店|net|yoga|fashion|luxe|love|kim|blue|pet|pink|移动|ski|ltd|chat|group|pub|run|city|live|ink|wiki|design|email|company|plus|video|center|cool|fund|gold|guru|life|show|team|today|world|zone|social|网站|bio|black|green|lotto|organic|poker|promo|vote|archi|voto|online|site|store|tech|fun|space|host|press|wang|商店|企业|娱乐|游戏|fit|icu|art|website|asia|我爱你|集团|biz|games|tax|studio|shopping|media|cash|fyi|vin|sale|mba|band|cab|fan|news|cafe|technology|market|fans|ren|cloud|co|shop|law|link|ac.cn|bj.cn|tj.cn|sh.cn|cq.cn|he.cn|ha.cn|sx.cn|nm.cn|ln.cn|jl.cn|hl.cn|js.cn|zj.cn|ah.cn|fj.cn|jx.cn|sd.cn|hb.cn|hn.cn|gd.cn|gx.cn|hi.cn|sc.cn|gz.cn|yn.cn|xz.cn|sn.cn|gs.cn|qh.cn|nx.cn|xj.cn|tw.cn|hk.cn|mo.cn)/;
      // 获取最后一个带点的数据
      const temp = this.search.match(domain);
      if (temp && temp.length > 0) {
        this.search = temp[0];
      } else {
        this.$Message.warning("请输入正确域名信息！");
        return false;
      }
      this.$router.push({ path: "/whois", query: { key: this.search } });
    },
  },
};
</script>


<style lang="less" scoped>
.section {
  background-color: #f0f3f6;
  padding: 160px 0 80px;
  .content {
    width: 1200px;
    margin: 0 auto;
    .search-input-warp :deep( ) {
      margin-top: 40px;
      width: 100%;
    }
    .whois-left {
      margin-top: 24px;
      background: #fff;
      padding: 20px 38px;
      .form-tit {
        font-size: 30px;
        font-weight: bold;
      }
      .form-stit {
        font-size: 18px;
        margin-top: 10px;
      }
    }
  }
  :deep(.search-input) {
    .ivu-input {
      height: 80px !important;
      padding: 0 0px 0 50px !important;
      font-size: 24px;
      line-height: 80px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      &:focus {
        box-shadow: none;
      }
    }
    .ivu-input-icon-clear {
      line-height: 80px;
      font-size: 24px;
    }
    .ivu-input-group-append {
      width: 170px;
    }
  }
  :deep(.search-btn) {
    height: 80px;
    padding: 0 45px;
    font-size: 22px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
